import { Component, OnInit } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-references-help-modal',
  templateUrl: './references-help-modal.component.pug',
  styleUrls: ['./references-help-modal.component.scss'],
  standalone: false
})
export class ReferencesHelpModalComponent implements OnInit {

  constructor(
    public modalService: BsModalService,
  ) { }

  ngOnInit(): void {
  }

  closeModal(): void {
    this.modalService.hide();
  }

}
